import { render, staticRenderFns } from "./AdCarousel.vue?vue&type=template&id=35b1d16f&scoped=true&"
import script from "./AdCarousel.vue?vue&type=script&lang=js&"
export * from "./AdCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AdCarousel.vue?vue&type=style&index=0&id=35b1d16f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1d16f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b1d16f')) {
      api.createRecord('35b1d16f', component.options)
    } else {
      api.reload('35b1d16f', component.options)
    }
    module.hot.accept("./AdCarousel.vue?vue&type=template&id=35b1d16f&scoped=true&", function () {
      api.rerender('35b1d16f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/AdCarousel.vue"
export default component.exports